import React from 'react';
import InputMask from 'react-input-mask';

import InputBase from 'apps/auth/components/form-multi/InputBase';
import { TO_SORT_CODE } from 'apps/auth/constants/fieldsName';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';
import { MASK_PHONE, MASK_STRING, getInputMode, getPlaceholderRule, getSeparatorsCount, isMaskPattern, padMaskPattern } from 'apps/auth/helpers/fieldMask';

const InputAccount = (props) => {
    const { field } = props;
    const hasMaxLength = props.setMaxLength && field?.maxLength;
    const separatorsCount = hasMaxLength ? getSeparatorsCount(field?.value, field?.mask) : 0;
    const value = props.customValue || field.value;

    const formatChars = { '*': /[^\s]/, '#': getPlaceholderRule(field.mask, field.checkRegexp) };

    const getMask = () => {
        if (field.providerId === 42276) {
            return null;
        }
        if (field.mask) {
            if (field.mask === MASK_STRING || field.mask === MASK_PHONE) {
                return null;
            }
            if (isMaskPattern(field.mask)) {
                return padMaskPattern(field.mask);
            }
            return field.mask;
        }
        return field.name === TO_SORT_CODE ? '** ** **' : '**** **** **** **** **** **** **** **** **** ****';
    };

    return (
        <InputMask
            mask={getMask()}
            maskChar={null}
            formatChars={formatChars}
            id={field.name}
            name={field.canonicalPath ? field.canonicalPath : field.name}
            value={value ?? ''}
            type="text"
            className={props.isNewInput ? null : 'field field-duo'}
            autoComplete="off"
            readOnly={field.isReadOnly || false}
            autoFocus={props.autoFocus}
            onFocus={props.onFocus}
            onChange={props.onChange}
            onBlur={props.onBlur}
        >
            {(inputProps) => (
                <input
                    {...inputProps}
                    maxLength={hasMaxLength ? +field.maxLength + separatorsCount : null}
                    inputMode={getInputMode(field.checkRegexp, field.mask)}
                />
            )}
        </InputMask>
    );
};

InputAccount.propTypes = inputPropType(['bank_account', 'pan', 'text', 'phone', 'digital']);

export default InputBase(InputAccount, false);
